import React from 'react';
import { ModalTheme } from '../../../../components/modal/index.jsx';
import { FORM_MESSAGE, useFormState } from '../forms/index.js';
import { useForm } from 'react-hook-form';
import { useCallback } from 'preact/hooks';
import { ButtonTheme, RenderForm, TextLarge, TextSmall } from '../../../../components/index.js';
import { ContainerButton } from '../../../../styles/global-style.js';
import { useSendMessage } from '../hooks/useSendMessage.js';

export const ModalMessage = ({ open, onToggle, initialValues }) => {
  const { control, setValue, handleSubmit } = useForm();

  const { mutate: sendMessage, isLoading } = useSendMessage();

  const onSubmitSuccess = useCallback(
    (formData) => {
      const payload = {
        claimId: initialValues.claimId,
        message: formData.message,
      };
      sendMessage(payload, {
        onSuccess: () => {
          onToggle({ defaultValues: '' });
        },
      });
    },
    [sendMessage, initialValues.claimId, onToggle],
  );

  return (
    <ModalTheme title=" " open={open} onToggle={onToggle} initialValues={initialValues}>
      <div style={{ textAlign: 'center', width: '100%' }}>
        <TextLarge text="ส่งข้อความ" />
      </div>
      <div>
        <TextSmall text={'ชื่อ : ' + initialValues.fullName} />
        <TextSmall text={'เลขที่เคลม : ' + initialValues.claimCode} />
      </div>
      <RenderForm control={control} forms={FORM_MESSAGE()} setValue={setValue} />
      <ContainerButton right>
        <ButtonTheme useFor="SUBMIT" onClick={handleSubmit(onSubmitSuccess)} loading={isLoading} />
        <ButtonTheme useFor="CANCEL" onClick={onToggle} />
      </ContainerButton>
    </ModalTheme>
  );
};
